import React, { createContext } from 'react';
import defaultTheme from '@weave-design/theme-data/build/json/lightGrayMediumDensityTheme/theme.json';
import PropTypes from 'prop-types';

const {
  Provider,
  Consumer: Consumer$1
} = /*#__PURE__*/createContext(defaultTheme);

function isPresent(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

function hasRoleFormat(prop) {
  return prop.search(/\./) > 0;
}

function resolvedRolesProxy(roles, theme) {
  if (typeof roles !== "object") return roles;
  return new Proxy(roles, {
    get: (obj, prop) => {
      if (hasRoleFormat(prop) && !isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error(`Role ${prop.toString()} does not exist`);
        return obj[prop];
      }

      const hasRoleDeprecationInfo = isPresent(theme, "metadata") && isPresent(theme.metadata, "__deprecated__") && isPresent(theme.metadata.__deprecated__, prop);

      if (hasRoleDeprecationInfo) {
        const roleDeprecationInfo = theme.metadata.__deprecated__[prop];
        const equivalencyInfo = roleDeprecationInfo.equivalent ? ` and has been renamed to ${roleDeprecationInfo.equivalent.toString()}.` : ".";
        /* eslint-disable-next-line no-console */

        console.warn(`Role ${prop.toString()} is deprecated${equivalencyInfo}`);
      }

      return obj[prop];
    }
  });
}

function createThemeProxy(theme) {
  return new Proxy(theme, {
    get: (obj, prop) => {
      const value = obj[prop];
      if (prop.toString() === "resolvedRoles") return resolvedRolesProxy(value, theme);

      if (!isPresent(obj, prop)) {
        /* eslint-disable-next-line no-console */
        console.error(`Property ${prop.toString()} does not exist.`);
        return value;
      }

      if (typeof value === "object" && value !== null) return createThemeProxy(value);
      return value;
    }
  });
}

const Consumer = props => /*#__PURE__*/React.createElement(Consumer$1, null, theme => {
  const isDebugging = process.env.NODE_ENV !== "production";
  const result = isDebugging ? createThemeProxy(theme) : theme;
  return props.children(result);
});

Consumer.displayName = "Consumer";
Consumer.propTypes = {
  /** A theme provided to the consumer within */
  children: PropTypes.func
};
Consumer.__docgenInfo = {
  "description": "",
  "displayName": "Consumer",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A theme provided to the consumer within"
    }
  }
};

var index = {
  Provider,
  Consumer
};

export { index as ThemeContext, index as default };
